// زر «طباعة» حديث: أيقونة طابعة SVG (بخطوط lucide) + لون أزرق مطابق لهوية التطبيق.
// يُحقن داخل نافذة التقرير على الحاسوب (لا React هنا) ويبقى مخفيّاً على الجوال.
import { esc } from "../payroll/reportFormat";

const PRINTER = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor"
  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <polyline points="6 9 6 2 18 2 18 9"/>
  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
  <rect x="6" y="14" width="12" height="8" rx="1"/></svg>`;

export const printButton = (L) =>
  `<button class="btn-print" data-testid="report-print" onclick="reportPrint()">${PRINTER}${esc(L.print)}</button>`;
